import React, { Component } from 'react';
import update from 'immutability-helper';
import { DragSource, DropTarget } from 'react-dnd';
import { isEqual } from 'lodash';

import { reorderTopOffers } from '../../mutations';
import { rowTarget, rowSource, addDndContext } from '../../utils/dndHelpers';

import TopOfferCell from './TopOfferCell';

const DISPLAYED_IN_MOBILE_APP = 15;

class TopOfferCellWrapper extends Component {
  render() {
    const { offer, isDragging, connectDragSource, connectDropTarget } =
      this.props;
    const opacity = isDragging ? 0 : 1;

    return (
      <TopOfferCell
        offer={offer}
        style={{ cursor: 'move', opacity }}
        trRef={(tr) => {
          connectDragSource(tr);
          connectDropTarget(tr);
        }}
      />
    );
  }
}

const OFFER = 'offer';

// The following looks weird because the library (react-dnd) assumes you're using ES7 decorators
// but it seemed like overkill to adjust the compiler to make this look a little prettier.
// It's what it would compile to anyway.
const SortableTopOfferCell = DropTarget(OFFER, rowTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}))(
  DragSource(OFFER, rowSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }))(TopOfferCellWrapper)
);

export class TopOffersList extends Component {
  state = {
    offers: this.props.offers,
  };

  moveRow = (dragIndex, hoverIndex) => {
    const { offers } = this.state;
    const dragOffer = offers[dragIndex];

    this.setState(
      update(this.state, {
        offers: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragOffer],
          ],
        },
      })
    );
  };

  handleClick = () => {
    const { relay } = this.props;
    const ids = this.state.offers.map((offer) => offer.id);
    reorderTopOffers(relay.environment, ids, {
      onCompleted: () => {
        window.alert('Successfully reordered offers');
      },
      onError: () => {
        window.alert('Failed to reorder offers');
      },
    });
  };

  render() {
    const { offers } = this.state;
    const offersOrderUnchanged = isEqual(offers, this.props.offers);

    return (
      <div>
        <div className="button-container">
          <button disabled={offersOrderUnchanged} onClick={this.handleClick}>
            Update Order
          </button>
        </div>

        <table className="tables">
          <thead>
            <tr>
              <th>Brand</th>
              <th>Title</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            {offers.map((offer, index) => (
              <SortableTopOfferCell
                key={offer.id}
                index={index}
                id={offer.id}
                offer={offer}
                moveRow={this.moveRow}
                fade={index >= DISPLAYED_IN_MOBILE_APP}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default addDndContext(TopOffersList);
